import { useSyncExternalStore } from "react";

/** SPEC D13: layout follows width, not device. */
export type LayoutMode = "phone" | "touch" | "desktop";

const touchQuery = "(min-width: 720px)";
const desktopQuery = "(min-width: 1024px)";

function current(): LayoutMode {
  if (window.matchMedia(desktopQuery).matches) {
    return "desktop";
  }
  return window.matchMedia(touchQuery).matches ? "touch" : "phone";
}

function subscribe(listener: () => void): () => void {
  const queries = [window.matchMedia(touchQuery), window.matchMedia(desktopQuery)];
  for (const q of queries) {
    q.addEventListener("change", listener);
  }
  return () => {
    for (const q of queries) {
      q.removeEventListener("change", listener);
    }
  };
}

export function useLayoutMode(): LayoutMode {
  return useSyncExternalStore(subscribe, current, () => "desktop");
}
